// import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";
import vanillaJSdocumentReadyHelper from "./helper/document-ready-helper";
import animateContentOnScroll from "./helper/animate-content-on-scroll";

import { scrollToID } from "./helper/helper";
import { initToggleDropdown } from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { initMbModal } from "./partials/mb-modal";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import initVideoThumb from "./theme/videoThumbnails";
import initPosttypeFilter from "./theme/posttypeFilter";
import initVideoPlayer from "./theme/videoPlayer";
import toggleFilterList from "./theme/toggleFilterList";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";

/**
 * Init JS Helper
 */
vanillaJSdocumentReadyHelper();
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    // initColorMode();

    animateContentOnScroll();
    initNavIcon();
    initToggleDropdown();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    initVideoThumb();
    initPosttypeFilter();
    initVideoPlayer();
    initMbModal();
    toggleFilterList();
    // mbYoutubeBorlabsGate();

    printDeveloperMessageToConsole();
  }

  init();

  // On document ready
  docReady(function (context) {});
})();

/**
 * Remove page loader
 */
jQuery(window).on("load", function () {
  jQuery(".mb-loader-wrapper").fadeOut("slow");
});

/**
 * Smooth Anker scrolling
 */
jQuery('a[href*="#"]').on("click", function (e) {
  const target = this.hash;
  scrollToID(target, -50);
  e.preventDefault();
});
